import { default as bigOccupationArea } from './big_occupation_area/services'

export default {
    ...bigOccupationArea,
    occupationAreas:        { method: 'get',    url: 'occupation_areas' },
    occupationAreaCreate:   { method: 'post',   url: 'occupation_areas' },
    occupationAreaUpdate:   { method: 'put',    url: 'occupation_areas/{id}' },
    occupationAreaDelete:   { method: 'delete', url: 'occupation_areas/{id}' },
}